import { combineReducers } from 'redux'
import sessionCoachListReducer from './coachList'
import { type CoachListState } from '../../../interfaces/coachList'
const coachListReducer = combineReducers<CoachListState>({
  coachList: sessionCoachListReducer
})
export default coachListReducer
